import { useTranslation } from 'react-i18next';
import React from 'react';

import UI from '../../common/UI';
import useProject from '../useProject';

const ProjectLayout = ({
  children,
}: { children: React.ReactNode }) => {
  const { t } = useTranslation();
  const project = useProject();

  return (
    <>
      <UI.Hero>
        <UI.Section sc={{ textAlign: 'center', compact: true }}>
          <UI.H1 sc={{ mb: 0 }}>
            {project.organisation_name}
          </UI.H1>
        </UI.Section>
        <UI.Container sc={{ px: [0, 4], textAlign: [undefined, 'center'] }}>
          <UI.Tabs>
            <UI.Tab to={`/${project.id}/project/organisation`}>{t('organisation')}</UI.Tab>
            <UI.Tab to={`/${project.id}/project/features`}>{t('features')}</UI.Tab>
            <UI.Tab to={`/${project.id}/project/payments`}>{t('payments')}</UI.Tab>
            <UI.Tab to={`/${project.id}/project/integrations`}>{t('integrations')}</UI.Tab>
            <UI.Tab to={`/${project.id}/project/privacy`}>{t('privacy')}</UI.Tab>
            <UI.Tab to={`/${project.id}/project/platform-fee`}>{t('platform_fee')}</UI.Tab>
            <UI.Tab to={`/${project.id}/project/users`}>{t('users')}</UI.Tab>
            <UI.Tab to={`/${project.id}/project/api`}>{t('api')}</UI.Tab>
          </UI.Tabs>
        </UI.Container>
      </UI.Hero>

      <UI.Section id="ProjectTab">
        {children}
      </UI.Section>
    </>
  );
};

export default ProjectLayout;
